const pageCopy = {
  journeySteps: {
    vi: [
      {
        title: "Khởi tạo dữ liệu",
        description: "Nhận dữ liệu từ HRM, ERP hoặc file chuẩn; tạo hợp đồng theo mẫu.",
      },
      {
        title: "Phê duyệt và ký",
        description: "Luồng nội bộ, phân quyền, ký số trên web, di động hoặc ứng dụng nghiệp vụ.",
      },
      {
        title: "Định danh người ký",
        description: "Mời ký, xác thực eID/VNeID và hỗ trợ mô hình ký không cần tài khoản.",
      },
      {
        title: "Bằng chứng giao dịch",
        description: "Chữ ký, chứng thư, dấu thời gian, chứng thực và nhật ký.",
      },
      {
        title: "ID và vòng đời",
        description: "Theo dõi cấp ID, phụ lục, tạm hoãn, chấm dứt, lưu trữ và tra cứu.",
      },
    ],
    en: [
      {
        title: "Data initiation",
        description:
          "Receive data from an HRM, ERP or standardized file and generate contracts from templates.",
      },
      {
        title: "Approval and signing",
        description:
          "Internal workflows, authorization and digital signing on the web, mobile devices or business applications.",
      },
      {
        title: "Signer identification",
        description:
          "Send signing invitations, authenticate through eID/VNeID and support accountless signing models.",
      },
      {
        title: "Transaction evidence",
        description: "Signatures, certificates, timestamps, authentication and logs.",
      },
      {
        title: "ID and lifecycle",
        description:
          "Monitor ID issuance, appendices, suspensions, termination, retention and searches.",
      },
    ],
  },
  lawChips: {
    vi: [
      "Luật Giao dịch điện tử 2023",
      "NĐ 337/2025/NĐ-CP",
      "TT 08/2026/TT-BNV",
      "Luật Bảo vệ dữ liệu cá nhân 2025",
    ],
    en: [
      "2023 Law on Electronic Transactions",
      "Decree No. 337/2025/ND-CP",
      "Circular No. 08/2026/TT-BNV",
      "2025 Personal Data Protection Law",
    ],
  },
  heroNotice: {
    vi: "Tài liệu giúp doanh nghiệp hiểu và chuẩn hóa quy trình, không thay thế ý kiến pháp lý cho một vụ việc cụ thể. Tính năng và phạm vi kết nối thực tế được xác định theo phương án triển khai, hạ tầng và trạng thái pháp lý của các bên cung cấp dịch vụ tại thời điểm ký hợp đồng.",
    en: "This handbook helps enterprises understand and standardize their processes; it does not replace legal advice for a specific matter. Actual features and connection scope depend on the implementation plan, infrastructure and legal status of the service providers at the time of contracting.",
  },
  referenceSources: {
    vi: [
      {
        label: "Nghị định 337/2025/NĐ-CP",
        href: "https://datafiles.chinhphu.vn/cpp/files/vbpq/2025/12/337-cp.signed.pdf",
      },
      {
        label: "Thông tư 08/2026/TT-BNV",
        href: "https://datafiles.chinhphu.vn/cpp/files/vbpq/2026/5/08-bnv.pdf",
      },
      {
        label: "Luật Giao dịch điện tử 2023",
        href: "https://datafiles.chinhphu.vn/cpp/files/vbpq/2023/8/luat20-2023-qh15..pdf",
      },
      {
        label: "Luật Bảo vệ dữ liệu cá nhân 2025",
        href: "https://congbao.chinhphu.vn/van-ban/luat-so-91-2025-qh15-45578.htm",
      },
      {
        label: "Tính năng GoPaperless",
        href: "https://gopaperless.mobile-id.vn/features",
      },
      {
        label: "Giải pháp tích hợp GoPaperless",
        href: "https://gopaperless.mobile-id.vn/solutions/e-identification-api",
      },
    ],
    en: [
      {
        label: "Decree No. 337/2025/ND-CP",
        href: "https://datafiles.chinhphu.vn/cpp/files/vbpq/2025/12/337-cp.signed.pdf",
      },
      {
        label: "Circular No. 08/2026/TT-BNV",
        href: "https://datafiles.chinhphu.vn/cpp/files/vbpq/2026/5/08-bnv.pdf",
      },
      {
        label: "2023 Law on Electronic Transactions",
        href: "https://datafiles.chinhphu.vn/cpp/files/vbpq/2023/8/luat20-2023-qh15..pdf",
      },
      {
        label: "2025 Personal Data Protection Law",
        href: "https://congbao.chinhphu.vn/van-ban/luat-so-91-2025-qh15-45578.htm",
      },
      {
        label: "GoPaperless features",
        href: "https://gopaperless.mobile-id.vn/features",
      },
      {
        label: "GoPaperless integration solutions",
        href: "https://gopaperless.mobile-id.vn/solutions/e-identification-api",
      },
    ],
  },
};

export function pickLang(value, lang) {
  const key = lang === "en" ? "en" : "vi";
  if (value && typeof value === "object" && ( "vi" in value || "en" in value)) {
    return value[key] ?? value.vi;
  }
  return value;
}

export default pageCopy;
